<template>
  <div class="guahaoqueren">
    <van-cell-group>
      <van-cell title="医生名称" :value="deptInfo.doctorName || '————'" />
      <!-- <van-cell title="挂号类型" value="预约挂号" /> -->
      <van-cell title="医生职称" :value="deptInfo.doctorTitle || '————'" />
      <van-cell title="就诊科室" :value="deptInfo.deptName" />
      <van-cell class="item-val" title="就诊时段" :value="`${deptInfo.day} ${deptInfo.noon === '1' ? '上午' : deptInfo.noon === '2' ? '下午' : '全天'}${deptInfo.startTime}`" />
      <van-cell class="item-val" title="挂号金额" :value="`￥${deptInfo.registerMoney}`" />
    </van-cell-group>
    <selectPatient @selectChange="selectChange" />
    <van-button :loading="btnLoading" type="info" class="guahaoqueren-btn" :disabled="!choosePatient.id" loading-text="加载中..." @click="querenFun">确认预约</van-button>
  </div>
</template>·
<script>
import selectPatient from '../../components/selectPatient'
export default {
  name: '',
  components: {
    selectPatient
  },
  filters: {
    noon: (val) => {
      switch (val) {
        case '1':
          return '上午'
        case '2':
          return '下午'
        case '3':
          return '全天'
        default:
          return ''
      }
    }
  },
  data() {
    return {
      choosePatient: '',
      deptInfo: '',
      btnLoading: false,
      time: ''
    }
  },
  created() {
    this.deptInfo = this.$route.query
    this.titleCode = localStorage.titleCode || ''
  },
  mounted() {
    this.time = this.$utils.dateFormat('YYYY-mm-dd', new Date())
  },
  methods: {
    selectChange(item) {
      this.choosePatient = item
    },
    getSelectData() {
      const deptInfo = this.deptInfo
      const choosePatient = this.choosePatient
      const parms = {
        deptId: deptInfo.deptId, // 挂号科室
        deptName: deptInfo.deptName, // 挂号科室名称
        doctorName: deptInfo.doctorName, // 医生姓名
        keepId: deptInfo.keepid || '', // 排班id 123
        patientId: choosePatient.id, // 患者id
        patientName: choosePatient.patientName, // 患者姓名
        registerType: 1, // 1 预约挂号
        titleName: deptInfo.doctorTitle, // 医生职称
        money: deptInfo.registerMoney,
        startTime: deptInfo.startTime && deptInfo.startTime.split('--')[0],
        endTime: deptInfo.startTime && deptInfo.startTime.split('--')[1],
        doctorId: deptInfo.doctorId || '', // 医生id
        doctorCode: deptInfo.doctorCode, // 医生code
        startNo: deptInfo.startNo || '', // 号源
        day: deptInfo.day, // 时间
        responseType: '1',
        preType: '6',
        scheduleNo: deptInfo.schemaId, // 排班号
        titleCode: this.titleCode
      }
      return parms
    },
    querenyuyue() {
      this.btnLoading = true
      const parms = this.getSelectData()
      this.$Apis.appointment(parms).then((res) => {
        this.btnLoading = false
        if (res.code === 200) {
          this.$router.push(`/guahaoxiangqing?id=${res.data}`)
          this.$notify.success('预约成功')
        } else {
          this.$dialog.alert({
            message: res.message || '预约失败',
            confirmButtonColor: '#1989fa'
          })
        }
      }).catch(() => {
        this.btnLoading = false
      })
    },

    querenFun() {
      if (!this.choosePatient.addressCode) {
        // this.$toast.warning('为了更好为您进行服务，请完善您的个人信息')
        // return false
        this.btnLoading = true
        this.$dialog.confirm({
          title: '提示',
          message: '为了更好为您进行服务，请完善您的个人信息',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          this.btnLoading = false
          this.$router.push(`/patientInfo?id=${this.choosePatient.id}&isEdit=${1}`)
          return false
        }).catch(() => {
          this.btnLoading = false
          // this.getYjfzInfo()
          this.querenyuyue()
        })
      } else {
        // this.getYjfzInfo()
        this.querenyuyue()
      }
    },
    getYjfzInfo() {
      this.btnLoading = true
      this.$Apis.getListByPatientId({
        patientId: this.choosePatient.id,
        startTime: `${this.time} 00:00:00`,
        endTime: `${this.time} 23:59:59`
      }).then(res => {
        if (res.code === 200) {
          this.btnLoading = false
          if (res.data.length) {
            this.querenyuyue()
          } else {
            this.$dialog.confirm({
              title: '提示',
              message: '请先填写预检分诊表',
              confirmButtonText: '去填写'
            }).then(() => {
              this.$router.push({ path: '/yujianfenzhenFormGh', query: { userInfo: JSON.stringify(this.choosePatient), type: 'add', showDialog: 'true' }})
            }).catch(() => {})
          }
        }
      })
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
.guahaoqueren{
  .item-val{
    /deep/.van-cell__value {
      color:#FCA237;
      padding-left: 20px;
    }
  }
  &-btn{
    display: block;
    width: 90%;
    margin: .2rem auto;
    border-radius: .2rem;
  }
}
</style>
